import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

import { FabShopStockProductType, RepositoryModal } from '../../shared'

@Component({
    templateUrl: './fab-shop-stock-product-type.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent],
})
export class FabShopStockProductTypeComponent extends RepositoryModal<FabShopStockProductType> {}
